import { UIHeading5, UIText2, UIText3, useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { Ticker } from 'shared/map-search/components/Ticker';
import { BANNER_ID } from 'shared/map-search/constants/banners';

import { DesktopSpecialProjectTemplate } from './DesktopSpecialProjectTemplate';
import * as desktopStyles from './DesktopSpecialProjectTemplate/styles.css';
import { MobileSpecialProjectTemplate } from './MobileSpecialProjectTemplate';
import * as mobileStyles from './MobileSpecialProjectTemplate/styles.css';
import { useAdfoxContext } from '../../../context/AdfoxContext';

import type { TSpecialProjectTemplateContext } from '../bannerTemplateTypes';

export interface ISpecialProjectTemplateProps {
  context: TSpecialProjectTemplateContext;
}

export const SpecialProjectTemplate: React.FC<ISpecialProjectTemplateProps> = ({ context }) => {
  const deviceType = useDeviceType();
  const { onTemplateClose, onTemplateClick, isSearchResultsOpen } = useAdfoxContext();
  const [bannerContainer, setBannerContainer] = React.useState<HTMLElement | null>(null);

  /**
   * Находит div контейнер созданный на ноде и маунтит в него баннер.
   * Нужно чтобы баннер отображался над шапкой (аналогично FSK MobileBanner).
   */
  React.useEffect(() => {
    if (deviceType !== 'desktop') {
      setBannerContainer(document.getElementById(BANNER_ID));
    }
  }, [deviceType]);

  if (deviceType === 'desktop') {
    return (
      <DesktopSpecialProjectTemplate
        url={context.url}
        title={<UIHeading5 color="text-inverted-default">{context.title}</UIHeading5>}
        description={<UIText2 color="text-inverted-default">{context.description}</UIText2>}
        image={context.image}
        logoImageUrl={context.logoImageUrl}
        copyright={<Ticker text={context.annotation ?? ''} />}
        isSearchResultsOpen={!!isSearchResultsOpen}
        onClose={onTemplateClose}
        onClick={onTemplateClick}
        rootClassName={desktopStyles['desktop-banner']}
      />
    );
  }

  if (!bannerContainer) {
    return null;
  }

  return ReactDOM.createPortal(
    <MobileSpecialProjectTemplate
      url={context.url}
      title={<UIHeading5 color="text-inverted-default">{context.title}</UIHeading5>}
      description={<UIText3 color="text-inverted-default">{context.description}</UIText3>}
      image={context.image}
      logoImageUrl={context.logoImageUrl}
      copyright={<Ticker text={context.annotation ?? ''} />}
      isSearchResultsOpen={!!isSearchResultsOpen}
      onClose={onTemplateClose}
      onClick={onTemplateClick}
      rootClassName={mobileStyles['mobile-banner']}
    />,
    bannerContainer,
  );
};
